import * as Sentry from '@sentry/astro';

Sentry.init({
  dsn: 'https://7ef337206a5317bfdc068def71f4d84e@o4509746060328960.ingest.us.sentry.io/4509746061443072',
  orgId: import.meta.env.SENTRY_ORG,
  // Adds request headers and IP for users, for more info visit:
  // https://docs.sentry.io/platforms/javascript/guides/astro/configuration/options/#sendDefaultPii
  sendDefaultPii: true,

  integrations: [],
});
